export default [
  {
    path: '/landing1',
    name: 'landing1',
    component: () => import('@/views/landing/Landing.vue'),
    meta:{
        pageTitle:'Home',
        breadcrumb: [
            {
                text: 'Home',
                active:true,
            },
        ],
        
    },
},
]